/**
 * LogRocket tracking event names.
 * All custom events sent to LogRocket should be listed in the enum below rather
 * than using a string (if the event name is static).
 */
export enum TrackingEvents {
  TransmitInit = 'login-transmit-init',
  InvalidMFAOptions = 'CIAM_MFA_INVALIDOPTIONS',
  TransmitRegisterDeviceLoad = 'login-transmit-register-device-load',
  TransmitRegisterDeviceSubmit = 'login-transmit-register-device-submit',
  TransmitAuthenticated = 'login-transmit-authenticated',
}
